import { useGetOmniClusterFromList } from 'features/cluster/autoscaler/edge-locations/hooks';
import { isClusterOmniEnabled } from 'utils/cluster';

import { useWasEnabled } from './useWasEnabled';

type OmniEnabledHookProps = {
  clusterId: string;
  onSuccess: () => void;
  onError: () => void;
  enabled: boolean;
};

export const useWasOmniEnabled = ({
  clusterId,
  onSuccess,
  onError,
  enabled,
}: OmniEnabledHookProps) => {
  const { clusterDetails, error } = useGetOmniClusterFromList({
    clusterId,
    refetchInterval: enabled ? 10_000 : false,
    enabled,
  });
  const isOmniEnabledCluster = isClusterOmniEnabled(clusterDetails);

  useWasEnabled({
    currentState: isOmniEnabledCluster,
    onSuccess,
    onError,
    error,
    enabled,
  });
};
